import { setLoading } from "../redux/app_global/reducer";
import { setLoading as setLoadingSpecialist, setSpecialist_id, setSpecialist_list, setSpecialist_my, setSpecialist_specialization, setSpecialist_organization } from "../redux/specialist/reducer";
import Request, { RequestFile } from "./handler.js";

export const getSpecialistSeo = async (data) => {
    var result = {};
    
    data.method = 'specialist_seo';

    await Request(data, 'post')
    .then(async json => {
        result = json;
    });

    return result;
}

export const getSpecialistSpecializationList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_specialization_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setSpecialist_specialization(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const getSpecialistList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setSpecialist_list(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const addSpecialistPhone = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_add_phone';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const getSpecialistMy = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_my';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setSpecialist_my(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const getSpecialistId = async (data,dispatch,profile) => {
    var result = {};
    
    data.method = 'specialist_id';

    if (profile.token) {
        data.token = profile.token;
    }

    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            if (Object.keys(json?.result).length > 0) {
                json.result['error_code'] = 200;
                await dispatch(setSpecialist_id(json?.result));
            } else {
                await dispatch(setSpecialist_id({error_code:404}));
            }
        }

        result = json;
    });

    return result;
}

export const getSpecialistOrganizationsList = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_organizations_list';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            await dispatch(setSpecialist_organization(json.result));
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const addSpecialist = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_add';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const addSpecialistEducation = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_add_education';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const addSpecialistExperience = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_add_experience';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const updSpecialistData = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_upd_data';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const updSpecialistSeo = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_upd_seo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const updSpecialistModeration = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_upd_moderation';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const updSpecialistDraft = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_upd_draft';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const updSpecialistLocation = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_upd_location';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const updSpecialistPhone = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_upd_phone';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const updSpecialistEducation = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_upd_education';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const updSpecialistExperience = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_upd_experience';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const delSpecialistPhone = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_del_phone';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const delSpecialistEducation = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_del_education';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const delSpecialistExperience = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_del_experience';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const delSpecialistPhotos = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_del_photos';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const delSpecialistCertificates = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_del_certificates';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}

export const delSpecialistPhoto = async (data,dispatch,profile) => {
    var result = {};
    
    await dispatch(setLoadingSpecialist(true));
    data.method = 'specialist_del_photo';

    if (profile.token) {
        data.token = profile.token;
    }
    
    await Request(data, 'post')
    .then(async json => {

        if (json?.code) {
            //Done
        }
        
        result = json;
    });
    await dispatch(setLoadingSpecialist(false));

    return result;
}